import React, { FC } from 'react';
import styles from './toggle-section.module.scss';
import Tooltip from "../tooltip/tooltip";

interface ToggleSectionProps {
    isOpen: boolean;
    children: React.ReactNode;
    label: string;
    tooltipText?: string;
    onToggle: () => void;
}

const ToggleSection: FC<ToggleSectionProps> = ({ isOpen = false, children, label, tooltipText, onToggle }) => {
    return (
        <div className={styles.toggleSection}>
            <div onClick={onToggle} className={styles.headerToggleSection}>
                <span>
                    {label} {tooltipText && <Tooltip position={isOpen ? 'right' : 'bottom'} text={tooltipText} />}
                </span>
                <button className={!isOpen ? styles.open : ''}>
                    <div className={styles.chevron}></div>
                </button>
            </div>
            <div className={`${styles.listChildren} ${isOpen ? styles.open : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default ToggleSection;
